import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { LeagalizationDocumentsListComponent } from './leagalization-documents-list/leagalization-documents-list.component';
import { LegalizationListComponent } from './legalization-list/legalization-list.component';
import { LegalizationFilesModalComponent } from './legalization-files-modal/legalization-files-modal.component';
import { LegalizationListFiltersComponent } from './legalization-list-filters/legalization-list-filters.component';
import { ExpansiveLeagalizationDocumentsListComponent } from './expansive-legalization-document-list/expansive-leagalization-documents-list.component';
import { SaveLegalizationInfoByLegalizerModalComponent } from './save-info-modals/save-legalization-info-by-legalizer/save-legalization-info-by-legalizer-modal.component';
import { AgreementsSectionComponent } from './save-info-modals/components/agreements-section/agreements-section.component';
import { LegalizationFileTypeSelectorComponent } from './save-info-modals/components/legalization-file-type-selector/legalization-file-type-selector.component';
import { SaveLegalizationInfoByCoordinatorComponent } from './save-info-modals/save-legalization-info-by-coordinator/save-legalization-info-by-coordinator.component';
import { SaveLegalizationInfoByEmployeeComponent } from './save-info-modals/save-legalization-info-by-employee/save-legalization-info-by-employee.component';
import { AssignLegalizationDocumentComponent } from './assign-legalization-document/assign-legalization-document.component';
import { LegalizationRegistryTabsContainerComponent } from './legalization-registry-tabs-container/legalization-registry-tabs-container.component';
import { LegalizationAllDocumentsListComponent } from './legalization-all-documents-list/legalization-all-documents-list.component';
import { EditLegalizationDocumentModalComponent } from './save-info-modals/components/edit-legalization-document/edit-legalization-document-modal.component';
import { LegalizationDetailsComponent } from './legalization-details/legalization-details/legalization-details.component';
import { SplitComponent } from '../split/components/split/split.component';
import { VirtualScrollModule } from '../virtual-scroll/virtual-scroll.module';
import { ListFilterModule } from '../list-filter/list-filter.module';
import { SuccessfullySumbitForLegalizationComponent } from './successfully-sumbit-for-legalization/successfully-sumbit-for-legalization.component';

@NgModule({
  declarations: [
    LeagalizationDocumentsListComponent,
    ExpansiveLeagalizationDocumentsListComponent,
    LegalizationListComponent,
    LegalizationFilesModalComponent,
    LegalizationListFiltersComponent,
    SaveLegalizationInfoByLegalizerModalComponent,
    AgreementsSectionComponent,
    LegalizationFileTypeSelectorComponent,
    SaveLegalizationInfoByCoordinatorComponent,
    SaveLegalizationInfoByEmployeeComponent,
    EditLegalizationDocumentModalComponent,
    LegalizationRegistryTabsContainerComponent,
    LegalizationAllDocumentsListComponent,
    LegalizationDetailsComponent,
    AssignLegalizationDocumentComponent,
    SuccessfullySumbitForLegalizationComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SplitComponent,
    VirtualScrollModule,
    ListFilterModule
  ],
  exports: [
    LeagalizationDocumentsListComponent,
    LegalizationListComponent,
    ExpansiveLeagalizationDocumentsListComponent
  ],
})
export class LegaliaztionsModule { }
